import { calcRatio } from '../utils/display'

function Ratio({ current, prev }: { current: number; prev: number }) {
  const diff = current - prev
  const ratio = prev !== 0 ? calcRatio(current, prev) : '-'

  if (diff >= 0) {
    if (prev === 0) {
      return <div className='text-sm text-black-900 font-medium'>-%</div>
    }
    return <div className='text-sm text-green-500 font-medium'>{`↑ ${ratio}%`}</div>
  }
  return <div className='text-sm text-red-500 font-medium'>{`↓ ${ratio}%`}</div>
}

export default Ratio
